import { useCurrentPublicCampaign } from '../campaign';

export const useLandingState = () => {
  const { campaignTemplates, loading } = useCurrentPublicCampaign();
  const templates = campaignTemplates?.templates?.items || [];

  return { templates, loading };
};
